import { render, staticRenderFns } from "./peopleTypeDialog.vue?vue&type=template&id=2bd226fa&scoped=true&lang=pug&"
import script from "./peopleTypeDialog.vue?vue&type=script&lang=js&"
export * from "./peopleTypeDialog.vue?vue&type=script&lang=js&"
import style0 from "./peopleTypeDialog.vue?vue&type=style&index=0&id=2bd226fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd226fa",
  null
  
)

export default component.exports